import { Fancybox } from '@fancyapps/ui'; // eslint-disable-line

export default ($) => {

	function loadFFIndex(searchTypeVal, terms1Val, terms2Val, terms3Val, searchin1Val, searchin2Val, searchin3Val, param1Val, param2Val, authorVal, editionVal, pageVal) {
		$.ajax({
			type : 'post',
			dataType : 'html',
			// url : '/wp-admin/admin-ajax.php',
			url : wp_params.ajaxurl,
			data : {
				action : 'load_ff_index',
				search_type : searchTypeVal,
				terms1 : terms1Val,
				terms2 : terms2Val,
				terms3 : terms3Val,
				search_in1 : searchin1Val,
				search_in2 : searchin2Val,
				search_in3 : searchin3Val,
				search_param1 : param1Val,
				search_param2 : param2Val,
				author : authorVal,
				edition : editionVal,
				page : pageVal
			},
			success : function(rd) {
				$('#ff-results-container-' + pageVal).html(rd);
				let ffListContainer = document.getElementById('ff-index-container');
				if (typeof ffListContainer !== 'undefined' && ffListContainer !== null) {
					ffListContainer.classList.remove('loading');
					ffSearchListeners(false);
					let ffResultsContainer = document.getElementsByClassName('js-ff-listings');
					if (typeof ffResultsContainer[0] !== 'undefined' && ffResultsContainer[0] !== null) {
						ffResultsContainer[0].setAttribute('data-page', pageVal);
						ffResultsContainer[0].setAttribute('data-search-type', searchTypeVal);
						ffResultsContainer[0].setAttribute('data-terms1', terms1Val);
						ffResultsContainer[0].setAttribute('data-terms2', terms2Val);
						ffResultsContainer[0].setAttribute('data-terms3', terms3Val);
						ffResultsContainer[0].setAttribute('data-search-in1', searchin1Val);
						ffResultsContainer[0].setAttribute('data-search-in2', searchin2Val);
						ffResultsContainer[0].setAttribute('data-search-in3', searchin3Val);
						ffResultsContainer[0].setAttribute('data-param1', param1Val);
						ffResultsContainer[0].setAttribute('data-param2', param2Val);
						ffResultsContainer[0].setAttribute('data-author', authorVal);
						ffResultsContainer[0].setAttribute('data-edition', editionVal);
					}
				}
			},
			error : function(MLHttpRequest, rd, errorMsg) {
				console.log(errorMsg);
			}
		});
	}

	function updateFFSearch(page) {
		let ffListContainer = document.getElementById('ff-index-container');
		let ffHeading = document.getElementById('results-heading');
		let newResContainerID = 'ff-results-container-' + page;
		let chkResContainer = document.getElementById(newResContainerID);

		if ((typeof chkResContainer === undefined || chkResContainer === null) && typeof ffListContainer !== 'undefined' && ffListContainer !== null ) {
			const newResContainer = document.createElement('div');
			newResContainer.id = newResContainerID;
			newResContainer.classList = 'ff-results-container';
			ffListContainer.appendChild(newResContainer);
		}

		if (typeof ffListContainer !== 'undefined' && ffListContainer !== null ) {
			ffListContainer.classList.add('loading');

			let searchTypeAdvanced = document.getElementById('ff-search-type-advanced');
			let searchType = 'simple';

			if (searchTypeAdvanced.checked) {
				searchType = 'advanced';
			}

			let terms1 = document.getElementById('ff-search-field1').value;
			let terms2 = document.getElementById('ff-search-field2').value;
			let terms3 = document.getElementById('ff-search-field3').value;
			let scope1 = document.getElementById('ff-search-in1').value;
			let scope2 = document.getElementById('ff-search-in2').value;
			let scope3 = document.getElementById('ff-search-in3').value;
			let parameter1 = document.getElementById('ff-search-param1').value;
			let parameter2 = document.getElementById('ff-search-param2').value;
			let author = document.getElementById('ff-author').value;
			let edition = document.getElementById('ff-edition').value;

			ffHeading.innerHTML = 'Fiddlehead Focus Archive <strong>Search Results</strong>';
			loadFFIndex(searchType, terms1, terms2, terms3, scope1, scope2, scope3, parameter1, parameter2, author, edition, page);
		}
	}

	function ffSearchListeners(init) {
		let searchTypeSimple = document.getElementById('ff-search-type-simple');
		let searchTypeAdvanced = document.getElementById('ff-search-type-advanced');
		let searchField1 = document.getElementById('ff-search-field1');
		let searchField2 = document.getElementById('ff-search-field2');
		let searchField3 = document.getElementById('ff-search-field3');
		let searchIn1 = document.getElementById('ff-search-in1');
		let searchIn2 = document.getElementById('ff-search-in2');
		let searchIn3 = document.getElementById('ff-search-in3');
		let searchParam1 = document.getElementById('ff-search-param1');
		let searchParam2 = document.getElementById('ff-search-param2');
		let author = document.getElementById('ff-author');
		let edition = document.getElementById('ff-edition');
		let loadMore = document.getElementsByClassName('js-load-ff');
		let submitBtn = document.getElementById('ff-submit-search');
		let resultsContainer = document.getElementsByClassName('js-ff-listings');

		if ( typeof searchTypeSimple !== 'undefined' && searchTypeSimple !== null ) {
			if (init === true) {
				loadFFIndex('simple', '', '', '', '', '', '', '', '', '', '', 1);
			}

			searchTypeSimple.addEventListener('change', function(e){
				if (searchTypeSimple.checked) {
					searchField1.parentNode.parentNode.classList.remove('_l10');
					searchField1.parentNode.parentNode.classList.add('_l12');
					searchField2.parentNode.parentNode.classList.add('hidden');
					searchField3.parentNode.parentNode.classList.add('hidden');
					searchIn1.parentNode.classList.add('hidden');
					searchIn2.parentNode.classList.add('hidden');
					searchIn3.parentNode.classList.add('hidden');
					searchParam1.parentNode.classList.add('hidden');
					searchParam2.parentNode.classList.add('hidden');
					author.parentNode.classList.add('hidden');
					edition.parentNode.classList.add('hidden');
				} else {
					searchField1.parentNode.parentNode.classList.add('_l10');
					searchField1.parentNode.parentNode.classList.remove('_l12');
					searchField2.parentNode.parentNode.classList.remove('hidden');
					searchField3.parentNode.parentNode.classList.remove('hidden');
					searchIn1.parentNode.classList.remove('hidden');
					searchIn2.parentNode.classList.remove('hidden');
					searchIn3.parentNode.classList.remove('hidden');
					searchParam1.parentNode.classList.remove('hidden');
					searchParam2.parentNode.classList.remove('hidden');
					author.parentNode.classList.remove('hidden');
					edition.parentNode.classList.remove('hidden');
				}
			});

			searchTypeAdvanced.addEventListener('change', function(e){
				if (searchTypeAdvanced.checked) {
					searchField1.parentNode.parentNode.classList.add('_l10');
					searchField1.parentNode.parentNode.classList.remove('_l12');
					searchField2.parentNode.parentNode.classList.remove('hidden');
					searchField3.parentNode.parentNode.classList.remove('hidden');
					searchIn1.parentNode.classList.remove('hidden');
					searchIn2.parentNode.classList.remove('hidden');
					searchIn3.parentNode.classList.remove('hidden');
					searchParam1.parentNode.classList.remove('hidden');
					searchParam2.parentNode.classList.remove('hidden');
					author.parentNode.classList.remove('hidden');
					edition.parentNode.classList.remove('hidden');
				} else {
					searchField1.parentNode.parentNode.classList.remove('_l10');
					searchField1.parentNode.parentNode.classList.add('_l12');
					searchField2.parentNode.parentNode.classList.add('hidden');
					searchField3.parentNode.parentNode.classList.add('hidden');
					searchIn1.parentNode.classList.add('hidden');
					searchIn2.parentNode.classList.add('hidden');
					searchIn3.parentNode.classList.add('hidden');
					searchParam1.parentNode.classList.add('hidden');
					searchParam2.parentNode.classList.add('hidden');
					author.parentNode.classList.add('hidden');
					edition.parentNode.classList.add('hidden');
				}
			});

			searchField1.addEventListener('keydown', function(e){
				if (e.keyCode === 13) {
					let ffListContainer = document.getElementById('ff-index-container');
					let resContainers = document.getElementsByClassName('ff-results-container');

					for (let rc=0; rc<resContainers.length; rc++) {
						if (resContainers[rc].id !== 'ff-results-container-1') {
							ffListContainer.removeChild(resContainers[rc]);
						}
					}
					updateFFSearch(1);
				}
			});

			submitBtn.addEventListener('click', function(e){
				e.preventDefault();
				let ffListContainer = document.getElementById('ff-index-container');
				let resContainers = document.getElementsByClassName('ff-results-container');

				for (let rc=1; rc<resContainers.length; rc++) {
					ffListContainer.removeChild(resContainers[rc]);
				}
				updateFFSearch(1);
			});

			submitBtn.addEventListener('keydown', function(e){
				e.preventDefault();
				if (e.keyCode === 13) {
					let page = parseInt(resultsContainer[0].getAttribute('data-page')) + 1;
					document.getElementById('results-next').remove();
					updateFFSearch(page);
				}
			});

			for (let lm=0; lm < loadMore.length; lm++) {
				loadMore[lm].addEventListener('click', function(e){
					e.preventDefault();
					let page = parseInt(resultsContainer[0].getAttribute('data-page')) + 1;
					document.getElementById('results-next').remove();
					updateFFSearch(page);
				});

				loadMore[lm].addEventListener('keydown', function(e){
					e.preventDefault();
					if (e.keyCode === 13) {
						let page = parseInt(resultsContainer[0].getAttribute('data-page')) + 1;
						document.getElementById('results-next').remove();
						updateFFSearch(page);
					}
				});
			}
		}
	}

	jQuery(document).ready(function(){
		ffSearchListeners(true);
	});
};